import { render, staticRenderFns } from "./ResumeList.vue?vue&type=template&id=242095da&"
import script from "./ResumeList.vue?vue&type=script&lang=js&"
export * from "./ResumeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports